var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("pz-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm.textFinal == 1 ? _vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.$t("views.final.text_final1.greetings")))];
  }) : _vm.textFinal == 2 ? _vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.$t("views.final.text_final2.greetings")))];
  }) : _vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.$t("views.final.greetings")))];
  })], 2), _c("span", {
    attrs: {
      slot: "sub_title"
    },
    slot: "sub_title"
  }, [_vm.textFinal == 1 ? _vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.$t("views.final.text_final1.sent_ok")))];
  }) : _vm.textFinal == 2 ? _vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.$t("views.final.text_final2.sent_ok")))];
  }) : _vm._t("default", function () {
    return [_vm._v(" " + _vm._s(_vm.$t("views.final.sent_ok")))];
  })], 2)]), _c("el-row", {
    staticClass: "pz-font-size-md",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "text-center",
    attrs: {
      span: 18,
      offset: 3
    }
  }, [_vm.textFinal == 1 ? _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_vm._v(_vm._s(_vm.$t("views.final.text_final1.data_received")))]) : _vm.textFinal == 2 ? _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_vm._v(_vm._s(_vm.$t("views.final.text_final2.data_received")))]) : _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_vm._v(_vm._s(_vm.$t("views.final.data_received")))]), _vm.textFinal == "" ? _c("el-col", {
    attrs: {
      span: 24
    }
  }, _vm._l(_vm.activities2, function (value, index) {
    return _c("p", {
      key: index,
      staticStyle: {
        "font-size": "0.8em"
      }
    }, [_vm._v(" " + _vm._s(value) + " ")]);
  }), 0) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };